import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DssAccordionComponent } from '@dss/components/accordion';
import { FaqItem } from '../../model/faq-model';
import { MonitoringService } from '../../services/monitoring.service';
import { PageService } from '../../services/page.service';
import { StorageModule } from '../../utils/storage.module';

@Component({
  selector: 'mob-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
  @ViewChild('accordion', { read: DssAccordionComponent, static: false })
  public accordion: DssAccordionComponent;
  // @ViewChild('drawer', { static: false }) drawer: ElementRef;
  @Input() faqItems: Array<FaqItem>;
  @Input() pageview?: any;

  title: string = "Precisa de ajuda?";
  subtitle: string = "Ver dúvidas frequentes";
  modalTitle: string = "Perguntas frequentes";
  closeText: string = "Fechar";

  isModalOpen: boolean = false;

  constructor(public pageService: PageService, public monitoringService: MonitoringService,
    public storage: StorageModule) {}

  closeFaqModal(ev) {}

  emitEvent() {
    this.monitoringService.click('botao:ver-duvidas-frequentes');
    this.monitoringService.send('faq');
  }

   closeAccordion() {
    this.accordion.ngAfterContentInit();
    return true;
  }

  eventEmitClick(event) {
      this.monitoringService.click('botao:fechar');
      const routeData = this.pageview.firstChild.children[0].snapshot.data;
      if (routeData && routeData.route  && routeData.route.path === 'feedback') {
        if (this.storage.getRecovery()) {
          this.monitoringService.send("feedback-check");
        } else {
          this.monitoringService.send("feedback-envio");
        }
      } else {
        this.monitoringService.send(routeData.route.path);
      }
  }

}
